import type { PAGE_POSITIONS } from 'types';
import type { ArticleCard as ArticleCardType } from 'types/capi/shared';

import ArticleCard from '~/components/ArticleCard';
import Metadata from '~/components/ArticleCard/Metadata';
import Tracked from '~/components/Tracked';
import ArticleCardInteractionEvent from '~/events/ArticleCardInteractionEvent';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';

type Props = {
  article: ArticleCardType;
  modulePosition: number;
  moduleType: string;
  pagePosition: PAGE_POSITIONS;
};

export default function Feature({
  article,
  modulePosition,
  moduleType,
  pagePosition
}: Props) {
  const { isBot } = useRootData();
  const user = useUser();

  const shared = {
    modulePosition,
    moduleType,
    name: 'LATEST_NEWS' as const,
    pagePosition,
    position: 1
  } as const;

  return (
    <div className="w-full bg-black">
      <div className="content-width py-10">
        <div className="hidden md:flex md:flex-row md:items-center md:gap-10">
          <Tracked.InternalLink
            to={article.link.path}
            variant="none"
            pagePosition={pagePosition}
            name="LATEST_NEWS"
            className="flex w-full flex-1 flex-col gap-4 text-start max-lg:min-w-[45vw]"
            onClick={() => {
              new ArticleCardInteractionEvent({
                articleId: article.id,
                gesture: 'click',
                guestId: user.guestId,
                isBot,
                modulePosition,
                moduleType,
                position: 1
              }).send();
            }}
          >
            <Metadata
              item={article}
              showSection
              size="lg"
              theme="dark"
              expanded
            />
          </Tracked.InternalLink>
          <div>
            <ArticleCard
              {...shared}
              className="block size-full lg:h-[570px] lg:w-[456px]"
              item={article}
              variant="4/5-text-over"
            />
          </div>
        </div>
        <ArticleCard
          {...shared}
          className="md:hidden"
          options={{
            expandedMetadata: true,
            showSection: true,
            theme: 'dark',
            titleSize: 'md'
          }}
          item={article}
          variant="16/9-text-under"
        />
      </div>
    </div>
  );
}
